import actions from './nodes/application/actions';

export const refStore = {
  sso: {
    onLoginSuccessRef: null,
    onClickDoThisLaterRef: null,
  },
};

const refHandler = () => next => (action) => {
  switch (action.type) {
    case actions.SET_SHOW_SSO_MODAL:
      refStore.sso.onLoginSuccessRef = action.refs.onLoginSuccess;
      refStore.sso.onClickDoThisLaterRef = action.refs.onClickDoThisLater;
      break;
    default:
      break;
  }
  const returnValue = next(action);
  return returnValue;
};

export default refHandler;
